import styled from 'styled-components'
import {
  ButtonTitle as UserButtonTitle,
  ButtonTitleQcs as UserButtonTitleQcs,
  UsersButtonWrap,
  UsersContainer,
  UsersControlLine,
  UserSearchWrap,
  UsersHeadlineWrap,
} from '../professionals/Professionals.styles'

export const ServiceUsersContainer = styled(UsersContainer)`
  position: relative;
`

export const ServiceUsersHeadlineWrap = styled(UsersHeadlineWrap)``

export const ServiceUsersControlLine = styled(UsersControlLine)``

export const ServiceUsersSearchWrap = styled(UserSearchWrap)``

export const ServiceUsersButtonWrap = styled(UsersButtonWrap)``

export const ButtonTitle = styled(UserButtonTitle)``

export const ButtonTitleQcs = styled(UserButtonTitleQcs)``
